import { POST_DATA_HALOTEL, TYPE_HALOTEL_REVENUE } from "./type";

const initialState = {
  revenue: [],
  postData: [],
};

export const reducerHalotel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_HALOTEL_REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    case POST_DATA_HALOTEL:
      return {
        ...state,
        postData: action.payload,
      };
    default:
      return state;
  }
};
